import React from "react";
import MusicUploaderIcon from "../../../../shared/Svg/MusicUploaderIcon";
import VideoUploaderIcon from "../../../../shared/Svg/VideoUploaderIcon";
import ImgUploaderIcon from "../../../../shared/Svg/ImgUploaderIcon";
import MediaUploaderModal from "../../../../shared/MediaUploaderModal";
import RollOver from "../../../../RollOver";
import ProfilePicture from "../../ProfilePicture";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Spinner } from "react-bootstrap";
import UploadedAttachments from "./UploadedAttachments";

interface Props {
  onSubmitComment: (comment_params: any) => void;
}

export default (props: Props) => {
  const { current_user } = useSelector(({ current_user }: any) => ({
    current_user,
  }));

  const {
    handleSubmit,
    handleChange,
    setFieldError,
    resetForm,
    values,
    isSubmitting,
    isValid,
    errors,
  } = useFormik({
    validateOnChange: false,
    initialValues: {
      text: "",
      attachments: null as any,
    },
    validationSchema: Yup.object({
      attachments: Yup.array().of(Yup.object()).nullable(),
      text: Yup.string()
        .when('attachments', {
          is: (attachments) => {
            return attachments && attachments.length > 0
          },
          then: Yup.string().nullable(),
          otherwise: Yup.string().required("You cannot post an empty comment")
        }),
    }),
    onSubmit: async (values) => {
      try {
        await props.onSubmitComment({ comment: { ...values } });
        resetForm();
      } catch (err) {
        setFieldError(
          "general",
          err.response.data.errors?.map((error: any) => error.message)
        );
      }
    },
  });

  const handleCommentEnterPress = (e: any) => {
    if (e.keyCode === 13) {
      handleSubmit();
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const setValue = (name: any) => (value: any) => {
    return handleChange({ target: { name, value } });
  };

  const handleMediaChange = (attachment: any) =>
    setValue("attachments")(
      Array.isArray(values.attachments)
        ? [...values.attachments, attachment]
        : [attachment]
    );

  const onRemoveAttachment = (attachmentToBeRemoved: any) =>
    setValue("attachments")(
      values.attachments.filter(
        (attachment: any) => attachment.id != attachmentToBeRemoved.id
      )
    );

  //console.log(values);

  return (
    <div className="d-flex flex-column">
      <div className="media align-items-center">
        <div className="media-body d-flex">
          <div className="comment-input d-flex justify-content-between align-items-center w-100">
            <input
              className="form-control"
              placeholder="Add your comment..."
              name="text"
              type="text"
              value={values.text}
              onChange={handleChange}
              onKeyDown={handleCommentEnterPress}
            />
          </div>
          <button
            className="btn comment-btn mt-1 ml-2 buttons"
            // @ts-ignore
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <Spinner animation={"border"} size={"sm"} />
            ) : (
              "Comment"
            )}
          </button>
        </div>
      </div>
      {errors.text || errors.attachments ? (
        <small className="alert alert-danger m-0">
          {[errors.attachments, errors.text].filter((a) => a).join(", ")}
        </small>
      ) : null}
      {values.attachments ? (
        <UploadedAttachments
          attachments={values.attachments}
          onRemoveAttachment={onRemoveAttachment}
        />
      ) : null}
    </div>
  );
};
